import React from 'react';
import PropTypes from 'prop-types';
import FormGroup from './form-group';
import ValueViewer from './value-viewer';
import humanize from 'underscore.string/humanize';
import underscored from 'underscore.string/underscored';
import Textarea from 'react-textarea-autosize';
import Messages, {messagesShape} from '../messages';
import style from './style.css';

export default class TextArea extends React.Component {

  static propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    value: PropTypes.string.isRequired,
    readOnly: PropTypes.bool.isRequired,
    editableByDefault: PropTypes.bool.isRequired,
    messages: messagesShape.isRequired,
    onChange: PropTypes.func.isRequired
  };

  static defaultProps = {
    editableByDefault: true,
    readOnly: false,
    onChange: () => null,
    messages: [],
    required: false,
    value: ''
  };

  constructor() {
    super(...arguments);
    const {editableByDefault, readOnly} = this.props;
    const editable = editableByDefault && !readOnly;
    this.state = {editable, focus: false};
  }

  componentWillReceiveProps(nextProps) {
    const {editableByDefault, readOnly} = nextProps;
    let {editable} = this.state;
    editable = (editable && !readOnly) || (!readOnly && editableByDefault);
    this.setState({editable});
  }

  makeEditable() {
    this.setState({editable: true, focus: true});
  }

  handleChange(e) {
    this.props.onChange(e.currentTarget.value);
  }

  handleBlur() {
    const {editableByDefault} = this.props;
    if (!editableByDefault) {
      this.setState({editable: false, focus: false});
    }
  }

  render() {
    const {name, label, value, messages, readOnly, ...props} = this.props;
    const {editable, focus} = this.state;
    const _name = underscored(name);
    // prevent the invalid prop type warning
    props.rows = parseInt(props.rows);
    delete props.editableByDefault;

    return (
      <FormGroup>
        <label
         className={style.fullWidth}
         htmlFor={_name}>{label ? label : humanize(name)}: </label>
        <div className={style.fullWidth}>
          {editable ?
            <Textarea
             {...props}
             name={_name}
             onChange={this.handleChange.bind(this)}
             value={value} autoFocus={focus}
             onBlur={this.handleBlur.bind(this)} /> :
            <ValueViewer
             readOnly={readOnly}
             emptyText="(empty)"
             makeEditable={this.makeEditable.bind(this)}>
              {value}
            </ValueViewer>}
        </div>
        {messages.length ? <Messages noIndent messages={messages} /> : null}
      </FormGroup>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/text-area.js